import { ApiStatus } from 'Enums';
import { generateLibreUserAgentHeader, urls } from 'Utilities/dataHelpers';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
export const getConnectionsService = (accountId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            name: 'getConnections',
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const deleteCaregiverInvitationService = (accountId, invitationId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountId}/connections/caregivers/invitations/${invitationId}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const resendCaregiverInviteService = (accountId, invitationId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountId}/connections/caregivers/invitations/${invitationId}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const deleteCaregiverConnectionService = (accountId, caregiverID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountId}/connections/caregivers/${caregiverID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const inviteCaregiverService = (email, firstName, lastName, accountId, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountId}/connections/caregivers/invitations`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                email,
                firstName,
                lastName,
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const acceptOrRejectPracticeInvitationService = (invitationID, accountID, action, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountID}/connections/practices/invitations/${invitationID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                action,
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK && result.data) {
                resolve(result.data);
                return;
            }
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const validatePracticeService = (businessID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        const headers = {
            'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
        };
        const baseUrl = urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/practices`;
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: baseUrl,
            headers,
            data: {
                businessID,
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            const error = err;
            // To ensure backwards compatibility, we need to use the GET method as fallback. This logic will be removed in 3.27 release.
            if (error.status === 404 && error.response?.data?.message === 'Not Found') {
                const encodedBusinessID = encodeURIComponent(businessID);
                return mediator
                    .request('api:invoke', {
                    method: 'GET',
                    url: baseUrl + `/${encodedBusinessID}`,
                    headers,
                })
                    .then((result) => {
                    if (result.data) {
                        resolve(result.data);
                        return;
                    }
                    reject(result);
                })
                    .catch((getErr) => {
                    log.error(getErr);
                    reject(getErr);
                });
            }
            log.error(err);
            reject(err);
        });
    });
};
export const addPracticeService = (practiceID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/practices/${practiceID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const removePracticeService = (practiceID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/practices/${practiceID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const removePartnerService = (partnerID, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/partners/${partnerID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const createNewDataShareService = (accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/data-share`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const stopDataShareService = (accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'DELETE',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/data-share`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const sharingCodeValidateService = (code, yearOfBirth, accountID, osType, osVersion, app, appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl +
                `v1/patients/${accountID}/connections/partners/sharing-code/validate`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                code,
                yearOfBirth,
            },
        })
            .then((result) => {
            if (result.data) {
                resolve(result.data);
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const acceptOrRejectPartnerConnectionService = (partnerID, accountID, action, osType, osVersion, app, appVersion, code, yearOfBirth) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'POST',
            url: urls.libreApiCountryUrl + `v1/patients/${accountID}/connections/partners/${partnerID}`,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            data: {
                action,
                code,
                yearOfBirth,
            },
        })
            .then((result) => {
            if (result.status === ApiStatus.OK && result.data) {
                resolve(result.data);
                return;
            }
            if (result.status === ApiStatus.NO_CONTENT) {
                resolve();
                return;
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const getPatientService = (patientId, authToken, osType, osVersion, app = 'libre1', appVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.libreApiCountryUrl + 'v1/patients/' + patientId,
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
                Authorization: `Bearer ${authToken}`,
            },
            name: 'getPatient',
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
export const getLibreConfig = (country = 'US', app, appVersion, osType, osVersion) => {
    return new Promise((resolve, reject) => {
        mediator
            .request('api:invoke', {
            method: 'GET',
            url: urls.libreApiCountryUrl + 'v1/config',
            headers: {
                'X-User-Agent': generateLibreUserAgentHeader(app, appVersion, osType, osVersion),
            },
            params: {
                country,
                compatibility: false,
            },
        })
            .then((result) => {
            if (result.data) {
                return resolve(result.data);
            }
            reject(result);
        })
            .catch((err) => {
            log.error(err);
            reject(err);
        });
    });
};
